<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="untitled-1">
<div class="calibre1">
<p class="normal-310-0-override"><span class="no-style-override"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override1">MELIA </span><span class="no-style-override2">RIDGE</span></p>
<p class="normal-310-0-override"><span class="no-style-override3"><br class="calibre2"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override4">A MAX BLAKE MYSTERY</span><span class="no-style-override5"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override5"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override5"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override6">WILLIAM FLORENCE</span><span class="no-style-override7"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override8"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override8"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override8"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override8"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span><img alt="A grayscale.jpg" class="generated-style" src="Images/MR01.jpeg"/></span><span class="no-style-override7"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override7"><a href="http://WildBluePress.com" target="_blank">WildBluePress.com</a><br class="calibre1"/></span></p>
<p class="calibre3" id="calibre_pb_0"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage2.vue?bedcb154